import { useScroll } from 'framer-motion';
import { useEffect, useState } from 'react';

/**
 * @param offset Amount to scroll down before triggering
 * @returns true if scrollY is larger than offset
 */
export const useIsScrolledDown = (offset = 0) => {
    const [isScrolledDown, setIsScrolledDown] = useState(false);
    const { scrollY } = useScroll();
    useEffect(() => {
        const unsubscribe = scrollY.onChange(() => {
            const isCurrentlyScrolledDown = scrollY.get() > offset;
            if (isScrolledDown != isCurrentlyScrolledDown) {
                setIsScrolledDown(isCurrentlyScrolledDown);
            }
        });
        return () => {
            unsubscribe();
        };
    }, [scrollY, offset, isScrolledDown, setIsScrolledDown]);
    return isScrolledDown;
};
